import "./bicycle-owner-root.component.scss";

export default {
  template: require('./bicycle-owner-root.component.html'),
  controller: function ($t, $auth, $gl, $alert, BicycleOwnerContactUsApi, vuiModals) {
    'ngInject';

    const self = this;

    self.auth = $auth;

    self.submitContactUs = message => {
      $gl.show();
      BicycleOwnerContactUsApi.send({body: message},
        response => {
          const successMessage = $t('shared.modals.contact_us.sending_success_message');
          vuiModals.info(successMessage);
          $gl.hide();
        },
        error => {
          $gl.hide();
          $alert.processError(error, $t('public.about.contact_us.send_message_error_message'));
        })
    }
  }
};
